import * as Session from 'supertokens-auth-react/recipe/session';

import { ISessionProvider } from './types';

// SuperTokens' SDK uses the browser's default fetch with no timeout, so a
// stalled connection (captive portal, WiFi handoff) can hang the refresh for
// the OS-level TCP timeout — minutes. Bound it so the cross-tab refresh lock's
// fallback path (10s) can rely on the holder having finished or given up.
const REFRESH_TIMEOUT_MS = 8_000;

/**
 * Uses the SuperTokens web sdk to provide session tokens.
 */
export class BrowserSessionProvider implements ISessionProvider {
  getAccessToken = Session.getAccessToken;
  getAccessTokenPayloadSecurely = Session.getAccessTokenPayloadSecurely;
  attemptRefreshingSession = async (): Promise<boolean> => {
    let timer: ReturnType<typeof setTimeout> | undefined;
    try {
      return await Promise.race([
        Session.attemptRefreshingSession(),
        new Promise<never>((_, reject) => {
          timer = setTimeout(
            () =>
              reject(
                new Error(
                  `Session.attemptRefreshingSession exceeded ${REFRESH_TIMEOUT_MS}ms`,
                ),
              ),
            REFRESH_TIMEOUT_MS,
          );
        }),
      ]);
    } finally {
      if (timer) clearTimeout(timer);
    }
  };
}
